import type { LanguageChoice } from '../../../i18n/languages';
import { describedPersonOf } from '../../../session';
import type { ServerSession } from '../../../session';

/** The signed-in person's own account, as the account screens show it. */
export interface AccountProfile {
  readonly name: string;
  readonly number: string | null;
  readonly email: string | null;
  readonly language: LanguageChoice;
  readonly isPhoneNumberVerified: boolean;
  readonly isEmailAddressVerified: boolean;
  /** Unknown when an older server leaves it out. */
  readonly passwordSet: boolean | undefined;
}

/** The account, once the server has described the person; throws a description it could not read. */
export const profileOf = (session: ServerSession): AccountProfile | undefined => {
  const person = describedPersonOf(session);
  if (person === undefined) return undefined;
  const { user, details } = person;
  return {
    name: user.name,
    number: details.number,
    email: user.email === '' ? null : user.email,
    language: details.language,
    isPhoneNumberVerified: details.phoneVerified,
    isEmailAddressVerified: details.emailVerified,
    passwordSet: details.passwordSet,
  };
};
